module.exports = __webpack_public_path__ + "img/topLogo-white.c9d183bf.png";